import {
  Component,
  OnInit,
  AfterViewInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  Renderer,
  Injectable,
} from "@angular/core";
import { Router, ActivatedRoute, RouterLinkActive } from "@angular/router";
import { EventNameService } from "../../services/event-name.service";
import Showcaser from "showcaser";
import { GlobalService } from "../../services/global.service";
import { ApiService } from "../../services/api.service";
import { AppConfig } from "../../config/app.config";
import { element } from "protractor";
import { Observable, Subject } from "rxjs";

@Component({
  selector: "app-dashboard",
  templateUrl: "./common-layout.component.html",
  styleUrls: ["./common-layout.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CommonLayoutComponent implements OnInit, AfterViewInit {
  @ViewChild("pubId") pubId: ElementRef;
  @ViewChild("moduleShowId") moduleShowId: ElementRef;
  @ViewChild("advId") advId: ElementRef;
  @ViewChild("customId") customId: ElementRef;
  userImg = undefined;
  public app: any;
  isActiveNav;
  whiteLabelCheck;
  public premium: any;
  public purchased: any;
  public headerThemes: any;
  public changeHeader: any;
  public sidenavThemes: any;
  public changeSidenav: any;
  public headerSelected: any;
  public sidenavSelected: any;
  public eventHeaderName: any;
  public organisationHeaderName: any;
  userName;
  moduleRoutes = {
    "1": "/programs/create",
    "2": "/materials/create",
    "3": "/news/create",
    "4": "/speakers/create",
    // "5": "/feedback/create",
    // "7": "/social/create",
    // "8": "/twitter/create",
    "5": "/webview/create",
  };
  sponsorModuleRoutes = {
    // "7": "/sponsers/create",
  };

  maduleList = [];
  sponsorModuleList = [];
  constructor(
    public globalService: GlobalService,
    private router: Router,
    public eventNameService: EventNameService,
    private render: Renderer
  ) {
    this.userName = localStorage.getItem("userName");
    this.app = {
      layout: {
        sidePanelOpen: false,
        isMenuOpened: true,
        isMenuCollapsed: false,
        themeConfigOpen: false,
        rtlActived: false,
      },
    };

    this.headerThemes = [
      "header-default",
      "header-primary",
      "header-info",
      "header-success",
      "header-danger",
      "header-dark",
    ];
    this.changeHeader = changeHeader;

    function changeHeader(headerTheme) {
      this.headerSelected = headerTheme;
    }
    this.sidenavThemes = ["sidenav-default", "side-nav-dark"];
    this.changeSidenav = changeSidenav;
    function changeSidenav(sidenavTheme) {
      this.sidenavSelected = sidenavTheme;
    }
  }

  ngOnInit() {
    this.whiteLabelCheck = localStorage.getItem("whiteLabelCheck");
    this.globalService.upgradeActive$.subscribe(
      (value: any) => {
        this.premium = value.prechecked;
        this.purchased = value.purchecked;
      },
      (error) => {}
    );
    this.purchased = localStorage.getItem("purchecked");
    this.premium = localStorage.getItem("prechecked");
    // console.log('sdfsfsf', this.premium);
    this.app.layout.isMenuCollapsed = false;
    this.userImg = localStorage.getItem("image");
    this.setEventName();
    this.getModuleNames();
    this.getSponsorModuleNames();
  }

  mouseEnterSidenav() {
    this.getModuleNames();
    this.getSponsorModuleNames();
  }

  onActivate(e, outlet) {
    window.scrollTo(0, 0);
  }

  onLogout() {
    const userId = localStorage.getItem("created_by");
    const dash = localStorage.getItem("dash");
    localStorage.clear();
    localStorage.setItem("created_by", userId);
    localStorage.setItem("dash", dash);
    this.router.navigateByUrl("/authentication/sign-in");
  }

  // Function to get the selected modules
  getModuleNames() {
    const eventId = localStorage.getItem("eventId");

    if (eventId) {
      // Initialize maduleList and a Set to track unique IDs
      this.maduleList = [];
      const seenIds = new Set(); // Use a Set to track seen moduleDetailsId

      // Function to add module data if it's unique
      const addModuleIfUnique = (moduleData) => {
        if (!seenIds.has(moduleData.moduleDetailsId)) {
          seenIds.add(moduleData.moduleDetailsId); // Mark as seen
          this.maduleList.push(moduleData);
        }
      };

      // Process data from all relevant keys (1 to 11)
      for (let i = 1; i < 16; i++) {
        const items = JSON.parse(localStorage.getItem(i.toString()));
        if (items) {
          items.forEach((modules) => {
            const [moduleName, moduleDetailsId, moduleOrder] = modules;
            addModuleIfUnique({
              eventModuleId: i,
              moduleName,
              moduleOrder,
              moduleRoutesC: this.moduleRoutes[i],
              moduleDetailsId,
            });
          });
        }
      }

      // Process specific key '5'
      const specificItems = JSON.parse(localStorage.getItem("5"));
      if (specificItems) {
        specificItems.forEach((modules) => {
          const [moduleName, moduleDetailsId, moduleOrder] = modules;
          addModuleIfUnique({
            eventModuleId: 5, // Or use `i` if you want to use the key as the eventModuleId
            moduleName,
            moduleOrder,
            moduleRoutesC: this.moduleRoutes[5], // Assuming this.moduleRoutes[5] is correct
            moduleDetailsId,
          });
        });
      }

      // Filter out entries without moduleName and sort by moduleOrder
      this.maduleList = this.maduleList
        .filter((item) => item.moduleName) // Keep only items with moduleName
        .sort((a, b) => a.moduleOrder - b.moduleOrder); // Sort by moduleOrder
    }

    console.log("Updated maduleList", this.maduleList);
  }

  // Function to get sponsors module list starts
  getSponsorModuleNames() {
    if (localStorage.getItem("eventId")) {
      this.sponsorModuleList = [];
      let i = 12;
      const items = JSON.parse(localStorage.getItem(i.toString()));
      if (items) {
        items.forEach((modules) => {
          this.sponsorModuleList[modules[2] - 1] = {
            eventModuleId: i,
            moduleName: modules[0],
            moduleOrder: modules[2],
            moduleRoutesC: this.sponsorModuleRoutes[i],
            moduleDetailsId: modules[1],
          };
        });
      }

      // console.log("madulelist ",this.sponsorModuleList);
      this.sponsorModuleList = this.sponsorModuleList.filter(Boolean);
      if (this.sponsorModuleList.length > 0) {
        const newArray = new Array();
        for (let i = 0; i < this.sponsorModuleList.length; i++) {
          if (this.sponsorModuleList[i].moduleName) {
            newArray.push(this.sponsorModuleList[i]);
          }
        }
        newArray.sort((a, b) => {
          return a.moduleOrder - b.moduleOrder;
        });

        this.sponsorModuleList = newArray;
      }
      // console.log("getSponsorModuleNames()",this.sponsorModuleList);
    }
  }
  // Function to get sponsors module list ends

  ngAfterViewInit() {
    this.eventHeaderName = localStorage.getItem("eventName");
    this.purchased = localStorage.getItem("purchecked");
    this.premium = localStorage.getItem("prechecked");

    this.organisationHeaderName = localStorage.getItem("organisation_name");
    this.getModuleNames();
    this.getSponsorModuleNames();
    if (localStorage.getItem("dash") == "0") {
      Showcaser.showcase(
        "Manage contents of modules",
        this.moduleShowId.nativeElement,
        {
          shape: "rectangle",
          positionTracker: true,
          scrollBufferPx: 0,
          before: () => {
            this.app.layout.isMenuCollapsed = true;
          },
          close: () => {
            this.customId.nativeElement.click();
          },
          position: {
            horizontal: "right",
            vertical: "middle",
          },
        }
      );

      Showcaser.showcase("Customise the module", this.customId.nativeElement, {
        shape: "rectangle",
        positionTracker: true,
        scrollBufferPx: 0,
        close: () => {
          this.pubId.nativeElement.click();
        },
        position: {
          horizontal: "right",
          vertical: "middle",
        },
      });

      Showcaser.showcase("Publish the Event", this.pubId.nativeElement, {
        shape: "rectangle",
        positionTracker: true,
        scrollBufferPx: 200,
        close: () => {
          this.app.layout.isMenuCollapsed = false;
        },
        position: {
          horizontal: "left",
          vertical: "bottom",
        },
      });
    }
  }

  setEventName() {
    // if (localStorage.getItem('eventName')) {
    //     this.eventHeaderName = localStorage.getItem('eventName');
    // }
    this.eventNameService.getPageInit().subscribe((value) => {
      this.getModuleNames();
    });

    this.eventHeaderName = this.eventNameService
      .getEventName()
      .subscribe((value) => {
        if (value == "initialState") {
          this.eventHeaderName = localStorage.getItem("eventName");
        } else {
          this.eventHeaderName = value;
          localStorage.setItem("eventName", value);
        }
      });
  }
  pricing() {
    window.location.href = "http://eventorg.co/#contact";
  }

  callModuleUrl(item) {
    this.router.navigateByUrl(item.moduleRoutesC + "/" + item.moduleDetailsId);
  }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/common/common-layout/common-layout.component.ts